// Lightweight carousel - replaces jQuery + Slick for article/page/section galleries
// Config: slidesToShow:3, centerMode, variableWidth, infinite, focusOnSelect
(function () {
  'use strict';

  // Swipe/drag constants, taken from the slick 1.6 defaults the galleries ran on —
  // the original init overrode none of them. Verified against the bundled build:
  //   swipe:true  draggable:true  touchMove:true  touchThreshold:5
  //   swipeToSlide:false  slidesToScroll:1  verticalSwiping:false
  // edgeFriction (0.35) is deliberately absent: slick only applied it when
  // infinite:false, and these galleries are infinite, so it never engaged.
  var SLIDES_TO_SHOW = 3;         // slick declines to swipe at or below this count
  var TOUCH_THRESHOLD = 5;        // minSwipe = list width / 5, i.e. 20% of the viewport
  var SLIDES_TO_SCROLL = 1;       // one slide per swipe (swipeToSlide:false)
  var PREVENT_DEFAULT_AFTER = 4;  // px of travel before we claim the gesture
  var CLICK_SUPPRESS_AFTER = 10;  // px of drag that cancels the follow-up click

  function initCarousels(selector) {
    var lists = document.querySelectorAll(selector);
    lists.forEach(function (ol) {
      if (ol.classList.contains('slick-initialized')) return;
      initCarousel(ol);
    });
  }

  function initCarousel(ol) {
    var items = Array.from(ol.children);
    if (items.length === 0) return;

    // Use the ol itself as the slick-slider wrapper (preserves ol tag for CSS)
    ol.classList.add('slick-slider', 'slick-initialized');

    var viewport = document.createElement('div');
    viewport.className = 'slick-list';

    var track = document.createElement('div');
    track.className = 'slick-track';

    // Move items into track
    items.forEach(function (item, i) {
      item.classList.add('slick-slide');
      item.setAttribute('data-slick-index', i);
      // Pin each image's aspect-ratio from its width/height attributes. Blur-up
      // placeholders (?width=24) round their tiny height, so the placeholder's ratio
      // differs slightly from the full image — making the slide a few px narrower
      // until it hydrates. As slides hydrate, the track outgrows its measured width
      // and the last slide wraps to a 2nd row (doubled height / blank space). Pinning
      // the accurate ratio (available immediately) keeps slide widths stable from
      // first paint. Done before cloning so the clones inherit it.
      var img = item.querySelector('img');
      if (img) {
        var aw = parseFloat(img.getAttribute('width'));
        var ah = parseFloat(img.getAttribute('height'));
        if (aw > 0 && ah > 0) img.style.aspectRatio = aw + ' / ' + ah;
      }
      track.appendChild(item);
    });

    var totalSlides = items.length;
    var currentIndex = 0;
    var slideWidth;

    // Clone slides for infinite loop (before and after)
    var cloneCount = Math.min(totalSlides, 3);

    // Prepend clones of last N slides
    for (var c = totalSlides - 1; c >= Math.max(0, totalSlides - cloneCount); c--) {
      var preclone = items[c].cloneNode(true);
      preclone.classList.add('slick-cloned');
      preclone.setAttribute('data-slick-index', c);
      track.insertBefore(preclone, track.firstChild);
    }

    // Append clones of first N slides
    for (var c = 0; c < cloneCount; c++) {
      var postclone = items[c].cloneNode(true);
      postclone.classList.add('slick-cloned');
      postclone.setAttribute('data-slick-index', c);
      track.appendChild(postclone);
    }

    // Assemble: viewport + track inside the ol, arrows as direct children of ol
    viewport.appendChild(track);
    ol.appendChild(viewport);

    // Arrows
    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'slick-prev slick-arrow icon-arrow-left2';
    prevBtn.setAttribute('aria-label', 'Previous');

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'slick-next slick-arrow icon-arrow-right2';
    nextBtn.setAttribute('aria-label', 'Next');

    ol.appendChild(prevBtn);
    ol.appendChild(nextBtn);

    var allSlides = Array.from(track.children);
    var isAnimating = false;
    var snapTimer = null;

    function setup() {
      updateSlidePositions();
      setPosition(getPositionForSlide(currentIndex + cloneCount), false);
      updateActiveClasses();
    }

    // Cache slide offsets
    var slideOffsets = [];
    var slideWidths = [];

    function updateSlidePositions() {
      // Give the track unlimited room before measuring so floated slides aren't
      // capped to the parent's width on first run (before track width is set).
      track.style.width = '99999px';
      slideOffsets = [];
      slideWidths = [];
      var offset = 0;
      allSlides.forEach(function (slide) {
        slideOffsets.push(offset);
        var w = slide.getBoundingClientRect().width;
        slideWidths.push(w);
        offset += w;
      });
      track.style.width = Math.ceil(offset) + 'px';
    }

    function getPositionForSlide(trackIndex) {
      // Center the slide in the viewport
      var viewportWidth = viewport.offsetWidth;
      var slideOffset = slideOffsets[trackIndex] || 0;
      var slideW = slideWidths[trackIndex] || 0;
      return -(slideOffset - (viewportWidth / 2) + (slideW / 2));
    }

    function setPosition(left, animate) {
      if (animate) {
        track.style.transition = 'transform 300ms ease';
      } else {
        track.style.transition = 'none';
      }
      track.style.transform = 'translate3d(' + Math.round(left) + 'px, 0, 0)';
    }

    // activeTrackIndex: which DOM node is actually centred right now. Normally that's
    // the real slide at currentIndex, so callers omit it. During a wrap-around move it
    // is NOT — the animation targets a clone's track index while currentIndex jumps to
    // the far end of the range, so `currentIndex + cloneCount` points at the real slide
    // sitting offscreen rather than the clone gliding into view. Marking the wrong node
    // left the incoming clone at .slick-slide's opacity:0.35 for the whole 300ms move,
    // then snapping to full opacity when the post-animation jump landed on the real
    // slide. The wrap branches pass the clone's index; the snap calls this again with
    // no argument to re-sync onto the committed slide.
    function updateActiveClasses(activeTrackIndex) {
      allSlides.forEach(function (slide) {
        slide.classList.remove('slick-current', 'slick-active');
        // Update cursor: active slide gets default, others get pointer
        var idx = parseInt(slide.getAttribute('data-slick-index'));
        slide.style.cursor = (idx === currentIndex) ? 'default' : 'pointer';
      });

      var trackIndex = (activeTrackIndex === undefined) ? currentIndex + cloneCount : activeTrackIndex;
      if (allSlides[trackIndex]) {
        allSlides[trackIndex].classList.add('slick-current', 'slick-active');
      }

      // Also mark visible neighbors as active
      if (allSlides[trackIndex - 1]) allSlides[trackIndex - 1].classList.add('slick-active');
      if (allSlides[trackIndex + 1]) allSlides[trackIndex + 1].classList.add('slick-active');

      // Prime the slide two to the right so it's decoded before it slides in.
      // The centered slide and its two immediate neighbors hydrate on their own —
      // they overlap the .slick-list box, so the blur-up IntersectionObserver sees
      // them. Anything further out is clipped to zero intersection by that box's
      // overflow:hidden, and rootMargin can't help: it expands the observer's root,
      // not an ancestor's clip. So the next-but-one slide only starts loading once
      // the user has already advanced onto it. Force it by index instead.
      primeSlide(trackIndex + 2);
    }

    // Hydrate a slide's blur-up image now, regardless of where it sits — along with
    // every twin of it (the real slide and its clones share data-slick-index). Blur-up
    // swaps src per <img>, not per file, so hydrating a clone leaves its real twin on
    // the 24px placeholder even though the full file is already cached. A wrap-around
    // move animates onto the clone, then snaps to the real slide at the far end of the
    // track — which then swapped in a few ms after landing: the flash going backward
    // from slide 1 to the last. Twins share srcset/sizes, so this costs no extra fetch.
    // Guarded so the repeated updateActiveClasses() calls (every image load, every
    // resize) don't re-enter loadImage on an image that's already mid-decode.
    function primeSlide(trackIndex) {
      var slide = allSlides[trackIndex];
      if (!slide) return;
      primeTwins(slide.getAttribute('data-slick-index'));
    }

    function primeTwins(slickIndex) {
      if (typeof initDrBlurUpLazyLoad !== 'function') return;
      allSlides.forEach(function (twin) {
        if (twin.getAttribute('data-slick-index') !== slickIndex || twin.dataset.drPrimed) return;
        twin.dataset.drPrimed = '1';
        initDrBlurUpLazyLoad(twin, { force: true });
      });
    }

    // Usage tracking: is anyone actually paging these galleries? Published as a Shopify
    // custom event, which only reaches pixels — a custom pixel in admin (Settings →
    // Customer events) forwards it to GA4 as dr_gallery_advance. Nothing in Shopify's
    // own reports shows custom events. The page URL rides along in the pixel's event
    // context, so the payload only needs to say which gallery and where it went.
    // goToSlide is only reached from arrows, slide clicks and swipes — never from init
    // or resize — so every event is a real visitor action.
    function publishAdvance(index, direction) {
      if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
      try {
        Shopify.analytics.publish('dr:gallery_advance', {
          gallery: Array.prototype.indexOf.call(document.querySelectorAll('ol.slick-initialized'), ol) + 1,
          gallery_type: ol.closest('.dr-section-slick-gallery') ? 'section' : 'body',
          slide: index + 1,
          total: totalSlides,
          direction: direction === -1 ? 'prev' : 'next'
        });
      } catch (e) {}
    }

    function goToSlide(index, direction) {
      if (isAnimating) return;

      if (snapTimer) {
        clearTimeout(snapTimer);
        snapTimer = null;
        setPosition(getPositionForSlide(currentIndex + cloneCount), false);
        updateActiveClasses();
      }

      // Normalize index into valid range
      if (index >= totalSlides) index = index - totalSlides;
      else if (index < 0) index = totalSlides + index;

      if (index === currentIndex) return;

      isAnimating = true;
      publishAdvance(index, direction);

      // Determine if direction and index movement disagree (need to go through clones)
      var goingRight = direction === 1;
      var goingLeft = direction === -1;
      var indexMovesRight = index > currentIndex;
      var indexMovesLeft = index < currentIndex;

      if (goingRight && indexMovesLeft) {
        // Going right but index wrapped lower — animate into appended clones
        var cloneTrackIndex = index + cloneCount + totalSlides;
        setPosition(getPositionForSlide(cloneTrackIndex), true);
        currentIndex = index;
        updateActiveClasses(cloneTrackIndex);

        snapTimer = setTimeout(function () {
          setPosition(getPositionForSlide(currentIndex + cloneCount), false);
          updateActiveClasses();
          snapTimer = null;
          isAnimating = false;
        }, 320);
      } else if (goingLeft && indexMovesRight) {
        // Going left but index wrapped lower — animate into the prepended clones, then
        // snap. Mirror of the goingRight case above. The prepend clone sits immediately
        // left of the current slide, so this is one ordinary animated move from the
        // committed position — no instant jump to flush, nothing offscreen to rasterize.
        var cloneTrackIndex = index - totalSlides + cloneCount;
        setPosition(getPositionForSlide(cloneTrackIndex), true);
        currentIndex = index;
        updateActiveClasses(cloneTrackIndex);

        snapTimer = setTimeout(function () {
          setPosition(getPositionForSlide(currentIndex + cloneCount), false);
          updateActiveClasses();
          snapTimer = null;
          isAnimating = false;
        }, 320);
      } else {
        // Normal slide — direction and index agree
        currentIndex = index;
        setPosition(getPositionForSlide(currentIndex + cloneCount), true);
        updateActiveClasses();

        setTimeout(function () {
          isAnimating = false;
        }, 320);
      }
    }

    prevBtn.addEventListener('click', function () {
      goToSlide(currentIndex - 1, -1);
    });

    nextBtn.addEventListener('click', function () {
      goToSlide(currentIndex + 1, 1);
    });

    // Click on non-active slides to navigate
    allSlides.forEach(function (slide, trackIdx) {
      slide.addEventListener('click', function () {
        var idx = parseInt(slide.getAttribute('data-slick-index'));
        if (idx === currentIndex) return; // active slide does nothing

        // Determine direction based on position relative to center slide
        var centerTrackIdx = currentIndex + cloneCount;
        var dir = trackIdx > centerTrackIdx ? 1 : -1;
        goToSlide(idx, dir);
      });
    });


    // - - - Swipe / drag - - -
    // Port of slick 1.6's swipe handling — the build this carousel replaced. The
    // galleries never overrode the swipe options, so the constants above are slick's
    // defaults, read back out of that bundled build. The track follows the finger 1:1
    // while dragging; on release it commits one slide if the horizontal distance
    // cleared minSwipe (list width / touchThreshold), otherwise it animates home.
    //
    // The CSS half is already live and unchanged: .slick-slider carries
    // `touch-action: pan-y` and `user-select: none` (assets/slick.css:8), so the
    // browser keeps the vertical axis and leaves the horizontal one to us.
    var touchObject = {};
    var dragging = false;
    var shouldClick = true;

    // Angle-based, exactly as slick: within 45 degrees of horizontal is a swipe;
    // anything steeper reports 'vertical' and is left alone so the page can scroll.
    function swipeDirection() {
      var xDist = touchObject.startX - touchObject.curX;
      var yDist = touchObject.startY - touchObject.curY;
      var angle = Math.round((Math.atan2(yDist, xDist) * 180) / Math.PI);
      if (angle < 0) angle = 360 - Math.abs(angle);
      if (angle <= 45 && angle >= 0) return 'left';
      if (angle <= 360 && angle >= 315) return 'left';
      if (angle >= 135 && angle <= 225) return 'right';
      return 'vertical';
    }

    function swipeStart(e) {
      var touches = e.touches;
      var fingerCount = touches ? touches.length : 1;

      // slick declines the gesture when there's nothing to scroll past the visible
      // window, or when a second finger is down (that's a pinch, not a swipe).
      if (fingerCount !== 1 || totalSlides <= SLIDES_TO_SHOW) {
        touchObject = {};
        return;
      }

      var point = touches ? touches[0] : e;
      touchObject = {
        startX: point.pageX,
        curX: point.pageX,
        startY: point.pageY,
        curY: point.pageY,
        swipeLength: 0,
        minSwipe: viewport.offsetWidth / TOUCH_THRESHOLD
      };
      dragging = true;
    }

    function swipeMove(e) {
      var touches = e.touches;
      if (!dragging || (touches && touches.length !== 1)) return;

      var point = touches ? touches[0] : e;
      touchObject.curX = point.pageX;
      touchObject.curY = point.pageY;
      touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));

      // Re-evaluated on every move, as slick did: while the gesture still reads as
      // vertical we neither move the track nor preventDefault, so the browser stays
      // free to scroll the page. The gesture only becomes ours once the angle flattens.
      if (swipeDirection() === 'vertical') return;

      if (touchObject.swipeLength > PREVENT_DEFAULT_AFTER && e.cancelable) e.preventDefault();

      // slick skipped the visual update while a slide animation was still in flight,
      // and read the committed offset fresh on each move rather than caching it at
      // gesture start. Both preserved here.
      if (isAnimating) return;

      var positionOffset = touchObject.curX > touchObject.startX ? 1 : -1;
      var curLeft = getPositionForSlide(currentIndex + cloneCount);
      setPosition(curLeft + touchObject.swipeLength * positionOffset, false);
    }

    function swipeEnd() {
      if (!dragging) return;
      dragging = false;

      // Kept in slick's exact polarity: an absent swipeLength must leave clicks
      // enabled, so this reads as `> n ? false : true`, not `<= n`.
      shouldClick = touchObject.swipeLength > CLICK_SUPPRESS_AFTER ? false : true;

      if (touchObject.curX === undefined) return;

      if (touchObject.swipeLength >= touchObject.minSwipe) {
        var direction = swipeDirection();
        if (direction === 'left') {
          goToSlide(currentIndex + SLIDES_TO_SCROLL, 1);
        } else if (direction === 'right') {
          goToSlide(currentIndex - SLIDES_TO_SCROLL, -1);
        } else {
          // slick committed nothing here and left the track wherever the gesture
          // abandoned it — reachable by starting flat, then curling the finger
          // downward. Animating home instead; the only intentional deviation.
          setPosition(getPositionForSlide(currentIndex + cloneCount), true);
        }
      } else if (touchObject.startX !== touchObject.curX) {
        // Under threshold: slick re-ran the current slide, i.e. animated back home.
        setPosition(getPositionForSlide(currentIndex + cloneCount), true);
      }

      touchObject = {};
    }

    // slick bound all of these on the list (our viewport), with mouseleave and
    // touchcancel both ending the gesture the same way a release does.
    viewport.addEventListener('touchstart', swipeStart, { passive: true });
    viewport.addEventListener('mousedown', swipeStart);
    viewport.addEventListener('touchmove', swipeMove, { passive: false });
    viewport.addEventListener('mousemove', swipeMove);
    viewport.addEventListener('touchend', swipeEnd);
    viewport.addEventListener('mouseup', swipeEnd);
    viewport.addEventListener('touchcancel', swipeEnd);
    viewport.addEventListener('mouseleave', swipeEnd);

    // slick killed the native HTML5 image drag inside the track
    // ($('[draggable!=true]', $slideTrack).on('dragstart', preventDefault)) — without
    // it a mouse drag lifts a ghost image instead of moving the carousel.
    track.addEventListener('dragstart', function (e) {
      var el = e.target;
      if (!el.getAttribute || el.getAttribute('draggable') !== 'true') e.preventDefault();
    });

    // slick swallowed the click that follows a real drag, so releasing over a
    // neighbouring slide doesn't also fire click-to-navigate. Capture phase here
    // because those handlers sit on the slides *inside* the viewport, so a bubbling
    // listener would run after them instead of before.
    viewport.addEventListener('click', function (e) {
      if (!shouldClick) {
        e.stopPropagation();
        e.preventDefault();
        shouldClick = true;
      }
    }, true);

    // Resize
    window.addEventListener('resize', function () {
      updateSlidePositions();
      setPosition(getPositionForSlide(currentIndex + cloneCount), false);
    });

    // Init
    setup();

    // Hydrate blur-up images, including the clones this carousel just created.
    // global.js runs initDrBlurUpLazyLoad() once before the carousel builds clones,
    // so the clones (and any not-yet-hydrated originals) need a re-scan here.
    // The selector skips .lazyloaded, so already-loaded images aren't re-fetched.
    if (typeof initDrBlurUpLazyLoad === 'function') {
      initDrBlurUpLazyLoad(ol);
    }

    // Load the whole gallery once it comes within range of the viewport, the way the
    // eager body galleries in blog posts already behave. Viewport hydration alone only
    // reaches the slides overlapping .slick-list (centre ±1 on desktop, less on mobile,
    // nothing to the left), and primeSlide covers just +2 — so stepping 1–2 slides back,
    // or 3+ forward, landed on a slide that hadn't started loading. These galleries run
    // 7–15 slides of ~100–200KB each, fetched only when the visitor scrolls near them.
    // Same 1200px margin as blur-up's own observer. Twins share srcset/sizes, so the
    // clones cost no extra fetch. To go back to on-demand loading, delete this block;
    // primeSlide and the viewport observer still handle the neighbours on their own.
    if (typeof initDrBlurUpLazyLoad === 'function' && 'IntersectionObserver' in window &&
        ol.querySelector('img.dr-blur-up-img[data-srcset]:not(.lazyloaded)')) {
      var galleryObserver = new IntersectionObserver(function (entries, obs) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        obs.disconnect();
        allSlides.forEach(function (slide) { slide.dataset.drPrimed = '1'; });
        initDrBlurUpLazyLoad(ol, { force: true });
      }, { rootMargin: '1200px 0px' });
      galleryObserver.observe(ol);
    }

    // Recalculate positions as images load (offsetWidth may be wrong before images render).
    // Guarded like the ResizeObserver below: blur-up hydration re-fires `load` on the
    // same <img> when it swaps in the full image, and that happens mid-slide (the click
    // primes the incoming slide). An unguarded setup() re-snapped the track with
    // transition:none, cutting the 300ms move short after ~4 frames — the choppy slide
    // on galleries further down the page — and re-marked the real slide active during a
    // wrap. Mid-animation we only re-measure; the move's own snap/settle re-syncs.
    function onImageSettled() {
      if (isAnimating) {
        updateSlidePositions();
        return;
      }
      setup();
    }

    var images = ol.querySelectorAll('img');
    images.forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', onImageSettled);
        img.addEventListener('error', onImageSettled);
      }
    });

    // Whenever any slide hydrates (IntersectionObserver or priming), hydrate its twins
    // too — see primeTwins. `load` doesn't bubble, so listen in the capture phase. A
    // hydrated img has a real srcset attribute; the placeholder only has data-srcset.
    track.addEventListener('load', function (e) {
      var img = e.target;
      if (img.tagName !== 'IMG' || !img.getAttribute('srcset')) return;
      var slide = img.closest('.slick-slide');
      if (!slide) return;
      slide.dataset.drPrimed = '1'; // already hydrated — don't re-enter it below
      primeTwins(slide.getAttribute('data-slick-index'));
    }, true);

    // Re-measure the track whenever a slide's rendered size settles or changes. Needed
    // because the track width is computed from slide widths at init, and a slide can
    // change size afterward: images without width/height attrs (e.g. body-gallery imgs
    // authored in the editor) have width 0 until they load, so the initial measurement
    // is too narrow and the last slide wraps to a 2nd row. The img `load` listeners
    // above miss cached/already-complete images, so this is the reliable path.
    //
    // Safe against the cycling glitch that an earlier version caused:
    //  - galleries whose imgs have width/height attrs get aspect-ratio pinned above, so
    //    blur-up hydration doesn't change their width → this never fires mid-cycle;
    //  - body-gallery imgs are eager, so they settle at load, not during cycling;
    //  - and we never re-snap the transform while an animation is in flight.
    if ('ResizeObserver' in window) {
      var roPending = false;
      var ro = new ResizeObserver(function () {
        if (roPending) return;
        roPending = true;
        requestAnimationFrame(function () {
          roPending = false;
          updateSlidePositions();
          if (!isAnimating) {
            setPosition(getPositionForSlide(currentIndex + cloneCount), false);
          }
        });
      });
      items.forEach(function (it) { ro.observe(it); });
    }
  }

  function init() {
    // All the different selectors used across article/page/section templates
    initCarousels('.article-template__content ol');
    initCarousels('.dr-section-slick-gallery ol');
    initCarousels('.main-content ol');
    initCarousels('.rte ol');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init galleries when sections are re-rendered in the theme editor
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }

  // Re-init galleries injected by Shopify CLI hot-reload during development
  var observer = new MutationObserver(function (mutations) {
    var needsInit = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.querySelector && (
          node.querySelector('.article-template__content ol') ||
          node.querySelector('.dr-section-slick-gallery ol') ||
          node.querySelector('.main-content ol') ||
          node.querySelector('.rte ol')
        )) {
          needsInit = true;
        }
      });
    });
    if (needsInit) init();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Also handle `has-image` class addition (was in article inline scripts)
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.article-template__content img, .article--content__bulletin img, .main-content .rte img, .rte img').forEach(function (img) {
      var p = img.closest('p');
      if (p) p.classList.add('has-image');
    });
  });
})();
